import { DatePipe } from '@angular/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { AppConfig } from 'src/app/app.config';
import { StreamStatusEnum } from 'src/app/enums/stream-status.enum';
import { ILiveDemonstrationSchedule } from 'src/app/models/live-demonstration-schedule.model';
import { ShopService } from 'src/app/services/shop.service';

@Component({
  selector: 'live-demonstration-card-inhome',
  templateUrl: '../../views/home/live-demonstration-card-inhome.component.html',
  styleUrls: [
    '../../../assets/css//home/live-demonstration-card-inhome.component.css',
  ],
})
export class LiveDemonstrationCardInHomeComponent implements OnInit, OnDestroy {
  schedules: ILiveDemonstrationSchedule[];
  private subscriptions = new Subscription();

  startIndex: number = 0;
  endIndex: number = 3;

  constructor(private shopService: ShopService, private datePipe: DatePipe) {}

  ngOnInit(): void {
    this.subscriptions.add(
      this.shopService
        .allSchedulesInLiveDemonstration()
        .subscribe((list: ILiveDemonstrationSchedule[]) => {
          this.schedules = list;
        })
    );
  }

  parseApiImageUrl(url: string): string {
    return url;
  }

  parseStreamStatus(
    statusEnumValue: StreamStatusEnum,
    startTime: Date
  ): string {
    switch (statusEnumValue) {
      case StreamStatusEnum.IN_PROGRESS:
        return 'On Air';
      case StreamStatusEnum.PENDING:
        return this.datePipe.transform(startTime, 'hh:mm a MMM yy');
    }
  }

  hasInProgressStatus(statusEnumValue: StreamStatusEnum): boolean {
    return statusEnumValue == StreamStatusEnum.IN_PROGRESS;
  }

  indexBetweenRange(index) {
    if (index >= this.startIndex && index <= this.endIndex) {
      return true;
    }

    return false;
  }

  displayNextItems() {
    if (this.endIndex + 1 > this.schedules.length) {
      this.startIndex = 0;
      this.endIndex = 3;
      return;
    }

    this.startIndex = this.startIndex + 1;
    this.endIndex = this.endIndex + 1;
  }

  displayPrevItems() {
    if (this.startIndex - 1 < 0) {
      this.startIndex = this.schedules.length - 4;
      this.endIndex = this.schedules.length - 1;
      return;
    }

    this.startIndex = this.startIndex - 1;
    this.endIndex = this.endIndex - 1;
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
